import { defineComponent as _defineComponent } from 'vue'
import { ref, computed, watch, onMounted } from "vue";
import { EarlytimeFlowDat } from "@/models/transaction/EarlytimeFlowDat";
import { VRow, VCol, VSelect } from "vuetify/lib";
import { InputRules } from "@/rules";
import TimePicker2 from "../TimePicker2.vue";
import {
  PulldownResponse,
  codeKbnFilter
} from "@/models/response/PulldownResponse";
import { CodeKbnList } from "@/models/codeMaster/Code";
import { Messages } from "@/message";
import { useApi } from "@/plugins/api/api";
import { DateTime, Duration } from "luxon";

type Props = {
  value: EarlytimeFlowDat;
  time?: string;
  adminView: boolean;
};
type Emits = {
  (e: "input", value: EarlytimeFlowDat): void;
};

export default /*#__PURE__*/_defineComponent({
  __name: 'EarlyWorkForm',
  props: {
    value: null,
    time: null,
    adminView: { type: Boolean }
  },
  emits: ["input"],
  setup(__props: any, { emit: emits }: { emit: ({
  (e: "input", value: EarlytimeFlowDat): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  value: EarlytimeFlowDat;
  time?: string;
  adminView: boolean;
};

const { Paths, $get } = useApi();




const reasonList = ref<string[]>([]);

const modelValue = computed({
  get: () => props.value,
  set: value => emits("input", value)
});

const adminView = computed(() => {
  return props.adminView;
});

const getCodeMaster = async () => {
  const code = await $get<PulldownResponse[]>(Paths.codeMasterPulldown);
  if (code) {
    reasonList.value = codeKbnFilter(code, CodeKbnList.OVRSN).map(e => e.name);
  }
};
const earlytimeRule = computed(() => {
  const from = props.value.earlytimeWorkStart;
  const to = props.time;
  if (from && to) {
    const a = DateTime.fromISO(from);
    const b = DateTime.fromISO(to);
    if (a.isValid && b.isValid) {
      if (adminView.value == true) {
        return a < b || `${to}よりも早い時間を選択してください。`;
      } else {
        const durEnd = b.minus(Duration.fromObject({ minutes: 15 }));
        const durStart = b.minus(Duration.fromObject({ hours: 2 }));
        return (
          (a >= durStart && a <= durEnd) ||
          `現在設定されているシフトの、${to}よりも前の時間を指定可能ただし、２時間以上前の申請は不可`
        );
      }
    }
  }
  return true;
});

onMounted(async () => {
  await getCodeMaster();
});

return { __sfc: true,Paths, $get, props, emits, reasonList, modelValue, adminView, getCodeMaster, earlytimeRule, VRow, VCol, VSelect, InputRules, TimePicker2, Messages }
}

})